import { IComponentSpecificForm } from '@/types/cms';
import { IDynamicsOptionSet } from '@/types/dynamicsForms';
import { IMetaData } from '@lamesarv-sdk/types';

export interface IFormProps extends IComponentSpecificForm {
  locationsOptionSet?: IDynamicsOptionSet;
  servicesOptionSet?: IDynamicsOptionSet;
  metadata?: IMetaData;
  successCallback?: () => void;
}

export interface IFormMetadataProps {
  ip?: string;
  user_agent?: string;
  platform?: string;
  geo_coordinates?: string;
  captcha_score?: number;
  captcha_threshold?: number;
  source_url?: string;
}

export enum FormType {
  contactInfo = 'contact-info',
  contactSell = 'contact-sell',
  contactSellSteps = 'contact-sell-steps',
  parts = 'parts',
  serviceAppointment = 'service-appointment',
  serviceAppointmentSteps = 'service-appointment-steps',
  stayUpdated = 'stay-updated',
  vanUpfit = 'van-upfit',
}

export interface IFormResetterProps {
  wasSuccessful: boolean;
  callback?: () => void;
  redirect?: string;
}
